"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GtldSection;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _filterColumn = _interopRequireDefault(require("./filter-column"));
var _gtldListColumn = _interopRequireDefault(require("./gtld-list-column"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _base = require("@site/pattern-library-utils/base.functions");
var _react2 = require("@linaria/react");
var _helpers = require("./helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FOLLOWING_CATEGORY_ID = -1;
const VIEW_ALL_CATEGORY_ID = 0;
const GtldComponentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GtldComponentContainer",
  class: "pl-gqmsx2k"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-cr654if"
});

/**
 * GtldSection Component.
 *
 * @param {Object} props - React props
 * @param {string} props.keywordTitle - Title for the keyword
 * @param {string} props.keywordPlaceholder - Placeholder text for the keyword input
 * @param {string} props.statusTitle - Title for the status
 * @param {string} props.availableStatusLabel - Label for 'Available' status
 * @param {string} props.preRegisterStatusLabel - Label for 'Pre-register' status
 * @param {string} props.comingSoonStatusLabel - Label for 'Coming Soon' status
 * @param {string} props.categoryTitle - Title for the category
 * @param {string} props.viewAllCategoryLabel - Label for 'View All' category option
 * @param {string} props.followingCategoryLabel - Label for 'Following' category option
 * @param {string} props.gtldAvailableText - Text for available gTLD
 * @param {string} props.gtldAvailableCta - CTA for available gTLD
 * @param {string} props.gtldPreRegisterText - Text for pre-register gTLD
 * @param {string} props.gtldPreRegisterCta - CTA for pre-register gTLD
 * @param {string} props.gtldComingSoonText - Text for coming soon gTLD
 * @param {string} props.gtldFollowingCta - CTA for following gTLD
 * @param {string} props.gtldFollowCta - CTA for follow gTLD
 * @param {string} props.noResultsMessage - Message to display when there are no results
 * @param {string} props.selectedCategoryId - ID of the selected category
 * @param {string} props.defaultFilterKeyword - Default filter keyword
 * @param {string} props.followUrl - URL to follow
 * @param {string} props.unfollowUrl - URL to unfollow
 * @param {string} props.followingGtldsUrl - URL to get following gTLDs
 * @param {Array} props.gtlds - Array of gTLDs. Each object in the array represents a gTLD
 * @param {number} props.gtlds[].id - Unique identifier of the gTLD
 * @param {string} props.gtlds[].name - Name of the gTLD
 * @param {string} props.gtlds[].url - URL associated with the gTLD
 * @param {number} props.gtlds[].p - GTLD Status (3 for 'Available', 2 for 'Pre-Register' and 0 for 'Coming Soon')
 * @param {number} props.gtlds[].w - Property representing if the gTLD is being followed (1 if it is, 0 if not)
 * @param {Array} props.gtlds[].c - Array of category IDs associated with the gTLD
 * @param {Array} props.categories - Array of category objects. Each object in the array represents a category
 * @param {number} props.categories[].id - Unique identifier of the category
 * @param {string} props.categories[].name - Name of the category
 * @param {string} props.basePagePath - Base page path
 * @param {string} props.ssoUrl - URL for single sign-on
 * @param {boolean} props.isUserTrusted - Indicates whether the user is trusted
 * @returns {React.ReactElement} GtldSection Component
 * @public
 */

// eslint-disable-next-line max-statements
function GtldSection({
  keywordTitle,
  keywordPlaceholder,
  statusTitle,
  availableStatusLabel,
  preRegisterStatusLabel,
  comingSoonStatusLabel,
  categoryTitle,
  viewAllCategoryLabel,
  followingCategoryLabel,
  gtldAvailableText,
  gtldAvailableCta,
  gtldPreRegisterText,
  gtldPreRegisterCta,
  gtldComingSoonText,
  gtldFollowingCta,
  gtldFollowCta,
  noResultsMessage,
  selectedCategoryId,
  defaultFilterKeyword,
  gtlds,
  categories,
  basePagePath,
  ssoUrl,
  followUrl,
  unfollowUrl,
  followingGtldsUrl,
  isUserTrusted
}) {
  const [keyword, setKeyword] = (0, _react.useState)(defaultFilterKeyword || '');
  const [checkedCategory, setCheckedCategory] = (0, _react.useState)(() => {
    const parsedId = parseInt(selectedCategoryId, 10);
    return isNaN(parsedId) ? VIEW_ALL_CATEGORY_ID : parsedId;
  });
  const [categoryList, setCategoryList] = (0, _react.useState)((0, _helpers.modifyCategories)(categories, VIEW_ALL_CATEGORY_ID, FOLLOWING_CATEGORY_ID, viewAllCategoryLabel, followingCategoryLabel));
  const [filteredGtldList, setFilteredGtldList] = (0, _react.useState)([]);
  const [followingGtlds, setFollowingGtlds] = (0, _react.useState)({});
  const [statusList, setStatusList] = (0, _react.useState)([{
    id: 3,
    statusLabel: availableStatusLabel,
    gtldText: gtldAvailableText,
    gtldCtaText: gtldAvailableCta,
    secondaryCtaText: 'null',
    buttonType: 'primary',
    count: 0,
    checked: true,
    value: '3'
  }, {
    id: 2,
    statusLabel: preRegisterStatusLabel,
    gtldText: gtldPreRegisterText,
    gtldCtaText: gtldPreRegisterCta,
    secondaryCtaText: 'null',
    buttonType: 'primary',
    count: 0,
    checked: true,
    value: '2'
  }, {
    id: 0,
    statusLabel: comingSoonStatusLabel,
    gtldText: gtldComingSoonText,
    gtldCtaText: gtldFollowCta,
    secondaryCtaText: gtldFollowingCta,
    buttonType: 'secondary',
    count: 0,
    checked: true,
    value: '0'
  }]);
  const [statusCounts, setStatusCounts] = (0, _react.useState)((0, _helpers.getStatusCountObj)(statusList));
  const [categoryCounts, setCategoryCounts] = (0, _react.useState)((0, _helpers.getCategoryCountObj)(categoryList));
  const {
    width
  } = (0, _base.useWindowSize)();
  const [isMobile, setIsMobile] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setIsMobile(width < _breakpoints.size.tabletLg);
  }, [width]);
  const updateGtldFollowingCount = () => {
    setCategoryCounts(prevCounts => ({
      ...prevCounts,
      [FOLLOWING_CATEGORY_ID]: Object.keys(followingGtlds).length
    }));
  };
  const updateGtldCounts = () => {
    const newCategoryCounts = {
      ...categoryCounts
    };
    const newStatusCounts = {
      ...statusCounts
    };
    newCategoryCounts[VIEW_ALL_CATEGORY_ID] = gtlds.length;
    newCategoryCounts[FOLLOWING_CATEGORY_ID] = Object.keys(followingGtlds).length;
    gtlds = (0, _base.sortWithEnglishFirst)(gtlds, 'name');
    gtlds = gtlds?.map(gtld => {
      if (!gtld.p) gtld.p = 0;
      if (gtld.p in newStatusCounts) {
        newStatusCounts[gtld.p] += 1;
      } else {
        newStatusCounts[gtld.p] = 1;
      }
      for (const category of gtld.c) {
        if (category in newCategoryCounts) {
          newCategoryCounts[category] += 1;
        } else {
          newCategoryCounts[category] = 1;
        }
      }
    });
    setCategoryCounts(newCategoryCounts);
    setStatusCounts(newStatusCounts);
  };
  const isStatusChecked = ({
    p
  }) => statusList.some(({
    id,
    checked
  }) => id === p && checked);
  const isFollowing = ({
    name
  }) => name in followingGtlds;
  const filterGtlds = () => {
    const filteredItems = gtlds?.filter(gtld => {
      const searchKey = keyword.toLowerCase().trim();
      const regex = new RegExp(searchKey, 'i');
      return (!keyword || regex.test(gtld.name.toLowerCase())) && isStatusChecked(gtld) && (checkedCategory === VIEW_ALL_CATEGORY_ID || checkedCategory === FOLLOWING_CATEGORY_ID && isFollowing(gtld) || gtld.c?.includes(checkedCategory));
    });
    setFilteredGtldList(filteredItems);
  };
  const handleSearch = value => {
    setKeyword(value);
  };
  const handleStatusSelection = statusId => () => {
    setStatusList(prevStatusList => prevStatusList?.map(item => item.id === statusId ? {
      ...item,
      checked: !item.checked
    } : item));
  };
  const updateCategorySelection = () => {
    setCategoryList(prevCategoryList => prevCategoryList?.map(item => ({
      ...item,
      checked: item.id === checkedCategory
    })));
  };
  const handleCategorySelection = categoryId => () => {
    setCheckedCategory(categoryId);
  };
  const generateGtldCta = (index, gtld) => () => {
    if (gtld.p !== 0) {
      window.location.href = gtld.url;
      return;
    }
    const gtldName = gtld.name.replace(/^\./, '');
    const params = new URLSearchParams({
      tld: gtldName
    });
    const baseUrl = isFollowing(gtld) ? unfollowUrl : followUrl;
    const url = new URL(baseUrl);
    url.search = params;
    if (typeof window !== 'undefined' && !isUserTrusted) {
      window.location = `${ssoUrl.replace(/&amp;/gi, '&')}${encodeURIComponent(basePagePath)}`;
      return;
    }
    fetch(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(async res => {
      if (res.status === 200) {
        setFollowingGtlds(prevFollowingGtlds => {
          const updatedFollowingGtlds = {
            ...prevFollowingGtlds
          };
          if (isFollowing(gtld)) {
            delete updatedFollowingGtlds[gtld.name];
          } else {
            updatedFollowingGtlds[gtld.name] = true;
          }
          return updatedFollowingGtlds;
        });
      }
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.error('Error during fetch:', error); // Logs any error during the fetch
    });
  };
  const generateCtaButtonType = ({
    p
  }) => {
    if (p === 0) {
      return 'secondary';
    } else if (p === 2) {
      return 'primary';
    } else if (p === 3) {
      return 'primary';
    }
  };
  (0, _react.useEffect)(() => {
    const fetchData = async () => {
      try {
        const data = await (0, _helpers.getFollowingGtlds)(followingGtldsUrl, gtlds);
        setFollowingGtlds(data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Error fetching the data:', e);
      }
    };
    fetchData();
  }, [gtlds]);
  (0, _react.useEffect)(updateCategorySelection, [checkedCategory]);
  (0, _react.useEffect)(filterGtlds, [categoryList, statusList, keyword, gtlds]);
  (0, _react.useEffect)(updateGtldCounts, [gtlds]);
  (0, _react.useEffect)(updateGtldFollowingCount, [followingGtlds]);
  return /*#__PURE__*/_react.default.createElement(GtldComponentContainer, {
    "data-cy": "gtld-section"
  }, /*#__PURE__*/_react.default.createElement(Content, {
    "data-cy": "gtld-content"
  }, /*#__PURE__*/_react.default.createElement(_filterColumn.default, {
    categoryList,
    checkedCategory,
    statusList,
    keyword,
    keywordTitle,
    keywordPlaceholder,
    categoryTitle,
    viewAllCategoryLabel,
    followingCategoryLabel,
    statusTitle,
    categoryCounts,
    statusCounts,
    isMobile,
    handleSearch,
    handleCategorySelection,
    handleStatusSelection
  }), /*#__PURE__*/_react.default.createElement(_gtldListColumn.default, {
    noResultsMessage,
    gtldList: filteredGtldList,
    generateGtldCta,
    generateCtaButtonType,
    statusList,
    isFollowing,
    isMobile
  })));
}
GtldSection.propTypes = {
  keywordTitle: _propTypes.default.string,
  keywordPlaceholder: _propTypes.default.string,
  statusTitle: _propTypes.default.string,
  availableStatusLabel: _propTypes.default.string,
  preRegisterStatusLabel: _propTypes.default.string,
  comingSoonStatusLabel: _propTypes.default.string,
  categoryTitle: _propTypes.default.string,
  viewAllCategoryLabel: _propTypes.default.string,
  followingCategoryLabel: _propTypes.default.string,
  gtldAvailableText: _propTypes.default.string,
  gtldAvailableCta: _propTypes.default.string,
  gtldPreRegisterText: _propTypes.default.string,
  gtldPreRegisterCta: _propTypes.default.string,
  gtldComingSoonText: _propTypes.default.string,
  gtldFollowingCta: _propTypes.default.string,
  gtldFollowCta: _propTypes.default.string,
  noResultsMessage: _propTypes.default.string,
  selectedCategoryId: _propTypes.default.string,
  defaultFilterKeyword: _propTypes.default.string,
  followUrl: _propTypes.default.string,
  unfollowUrl: _propTypes.default.string,
  followingGtldsUrl: _propTypes.default.string,
  gtlds: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    url: _propTypes.default.string,
    p: _propTypes.default.number,
    w: _propTypes.default.number,
    c: _propTypes.default.arrayOf(_propTypes.default.number)
  })),
  categories: _propTypes.default.array,
  basePagePath: _propTypes.default.string,
  ssoUrl: _propTypes.default.string,
  isUserTrusted: _propTypes.default.bool
};